import { useState, useEffect } from 'react';
import { useTemplateString } from '../../useTemplateString';

export const useAggregatorDisplay = ({
  text,
  persistedText,
  qwantumId,
  currentTime,
  offspringCards,
  payable,
  receivable,
  balance,
  stackCount,
  payables,
  context
}) => {
  const [, setForceUpdate] = useState(0);
  const { processTemplateString } = useTemplateString();

  // Update time every second when currentTime is enabled
  useEffect(() => {
    if (currentTime) {
      const interval = setInterval(() => {
        setForceUpdate(prev => prev + 1);
      }, 1000);
      return () => clearInterval(interval);
    }
  }, [currentTime]);

  const getCurrentTime = () => {
    const now = new Date();
    const day = now.getDate().toString().padStart(2, '0');
    const month = (now.getMonth() + 1).toString().padStart(2, '0');
    const year = now.getFullYear();
    const hours = now.getHours().toString().padStart(2, '0');
    const minutes = now.getMinutes().toString().padStart(2, '0');
    const seconds = now.getSeconds().toString().padStart(2, '0');
    return `${day}:${month}:${year} ${hours}:${minutes}:${seconds}`;
  };

  const getDisplayContent = () => {
    // Use persisted text if qwantumId exists, otherwise use prop text
    const sourceText = qwantumId ? (persistedText || "") : text;

    // Process template strings
    const displayText = processTemplateString(sourceText);

    // Add superpowers as table rows
    const superpowerRows = [];

    if (currentTime) {
      superpowerRows.push({
        value: getCurrentTime(),
        label: 'Time:'
      });
    }

    if (offspringCards) {
      const cardInfo = context ? context.cardCount : 'Enabled';
      superpowerRows.push({
        value: cardInfo,
        label: 'Cards:'
      });
    }

    if (payable) {
      if (context?.cards && context.cards.length > 0) {
        const totalPayables = context.cards.reduce((sum, card) => {
          if (card?.invoicetype === "payable") {
            const amount = parseFloat(card?.amount) || 0;
            return sum + amount;
          }
          return sum;
        }, 0);
        superpowerRows.push({
          value: totalPayables.toFixed(2),
          label: 'Payables:'
        });
      } else {
        superpowerRows.push({
          value: '0.00',
          label: 'Payables:'
        });
      }
    }

    if (receivable) {
      if (context?.cards && context.cards.length > 0) {
        const totalReceivable = context.cards.reduce((sum, card) => {
          if (card?.invoicetype === "receivable") {
            const amount = parseFloat(card?.amount) || 0;
            return sum + amount;
          }
          return sum;
        }, 0);
        superpowerRows.push({
          value: totalReceivable.toFixed(2),
          label: 'Receivable:'
        });
      } else {
        superpowerRows.push({
          value: '0.00',
          label: 'Receivable:'
        });
      }
    }

    if (balance) {
      if (context?.cards && context.cards.length > 0) {
        const totalReceivable = context.cards.reduce((sum, card) => {
          if (card?.invoicetype === "receivable") {
           const amount = parseFloat(card?.amount?.replace(',', '.')) || 0;
            return sum + amount;
          }
          return sum;
        }, 0);
        
        const totalPayables = context.cards.reduce((sum, card) => {
          if (card?.invoicetype === "payable") {
            const amount = parseFloat(card?.amount?.replace(',', '.')) || 0;
            return sum + amount;
          }
          return sum;
        }, 0);
        
        const balanceAmount = totalReceivable - totalPayables;
        superpowerRows.push({
          value: balanceAmount.toFixed(2),
          label: 'Balance:'
        });
      } else {
        superpowerRows.push({
          value: '0.00',
          label: 'Balance:'
        });
      }
    }

    if (stackCount) {
      const stackInfo = context ? `${context.cardCount} cards` : 'Loading...';
      superpowerRows.push({
        value: stackInfo,
        label: 'Stack:'
      });
    }

    return {
      text: displayText,
      superpowerRows
    };
  };

  return {
    displayContent: getDisplayContent(),
    rawText: processTemplateString(qwantumId ? (persistedText || "") : text)
  };
};